import { useState } from 'react';

const faqs = [
  {
    q: '紅桃視頻是免费的吗？',
    a: '是的，紅桃視頻完全免费！所有视频内容均可免费观看，无需任何付费。我们通过广告和品牌合作来维持平台运营，用户可以享受完全免费的优质内容体验。',
  },
  {
    q: '紅桃視頻支持哪些设备？',
    a: '紅桃視頻支持iOS和Android系统的手机和平板设备。您可以在App Store和各大安卓应用市场搜索"紅桃視頻"下载官方App。我们也提供网页版，在电脑上也能观看。',
  },
  {
    q: '如何成为紅桃視頻的创作者？',
    a: '下载紅桃視頻App后，注册账号即可开始创作。我们为创作者提供了丰富的拍摄和剪辑工具，还有完善的创作者扶持计划，包括流量扶持、收益分成和专业培训。',
  },
  {
    q: '视频画质最高支持多少？',
    a: '紅桃視頻支持最高4K超高清画质播放。我们会根据您的网络状况自动调整画质，同时您也可以在播放设置中手动选择画质。所有视频默认采用先进的压缩技术，在保证高清的同时节省流量。',
  },
  {
    q: '遇到问题如何联系客服？',
    a: '您可以通过以下方式联系我们：在App内点击"我的-帮助与反馈"提交问题，或发送邮件至 support@rwgjqtpido.cn，我们的客服团队会在24小时内回复。您也可以关注我们的官方微博和微信公众号获取帮助。',
  },
  {
    q: '紅桃視頻的推荐算法是怎样的？',
    a: '紅桃視頻采用自研的智能推荐算法，综合考虑您的观看历史、点赞、收藏、完播率等行为数据，为您精准推荐可能感兴趣的内容。我们始终坚持内容质量优先，杜绝低俗内容推荐。',
  },
];

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            关于紅桃視頻，你可能想知道的一切
          </p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-lg bg-background-100 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left"
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.q}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIdx === idx ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-600 text-lg"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIdx === idx ? 'max-h-96 pb-4 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}